import Box from './Box';
import type { Margin, Padding, BoxProps } from './Box';
import boxProps, { omitBoxProps, pickBoxProps } from './boxProps';

export default Box;
export { Box, boxProps, omitBoxProps, pickBoxProps, Margin, Padding, BoxProps };
